import { commandCounsellorAddComponent } from './command-counsellor-add.component';
import './command-counsellor-add.scss';

export const commandCounsellorAdd = angular
	.module('components.command-counsellor-groups.command-counsellor-groups-details.command-counsellor-add.commandCounsellorAdd', [])
	.component('commandCounsellorAdd', commandCounsellorAddComponent)
	.config(($stateProvider) => {
		'ngInject';

		$stateProvider
			.state('commandCounsellorAdd', {
				parent: 'app',
				url: '/home/command-counsellor-groups/details/:groupId/:unitIdentificationCode/add',
				breadcrumbName: 'ADD TRANSITION MANAGER',
				parentState: 'commandCounsellorGroupsDetails',
				component: 'commandCounsellorAdd',
				resolve: {
					details(CommandCounsellorGroupsService, $stateParams) {
						"ngInject";
						return CommandCounsellorGroupsService.getEligibleTransitionManagers($stateParams.unitIdentificationCode);
					},
					groupData($stateParams) {
						"ngInject";
						return $stateParams;
					},
				}
			});
	})
	.name;


// WEBPACK FOOTER //
// ./src/app/components/command-counsellor-groups/command-counsellor-groups-details/command-counsellor-add/command-counsellor-add.module.js